export enum InvatationType {
  Invite = 1,
  Request = 2,
}
